// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type GetFolderChangeDigestRequest from "../contract/GetFolderChangeDigestRequest";

export default function getFolderChangeDigestRequest(data: GetFolderChangeDigestRequest): GetFolderChangeDigestRequest {
    const result: GetFolderChangeDigestRequest = {
        __type: "GetFolderChangeDigestRequest:#Exchange",
        ...data,
    };
    
    return result;
}
